export default __webpack_public_path__ + "static/media/ncar.2d7014f1.jpg";